import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import Reveal from "@/components/Reveal";
import { MapleMark } from "@/components/MapleMark";
import { SITE } from "@/config/site";

export default function FinalCTA() {
  return (
    <section className="noise-dark relative overflow-hidden bg-brand-deep py-24 text-white lg:py-28">
      <MapleMark
        className="pointer-events-none absolute -bottom-12 -right-10 h-72 w-72 text-white/5"
      />
      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-6 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-7">
          <Reveal>
            <h2 className="font-cabinet text-4xl font-extrabold leading-[1.05] tracking-tighter sm:text-5xl">
              Ready to spend less time managing the books?
            </h2>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-4 max-w-xl text-lg leading-relaxed text-white/70">
              Let Postings handle the bookkeeping and payroll so you can concentrate on running
              your business.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.14} className="lg:col-span-5">
          <div className="flex flex-wrap gap-3 lg:justify-end">
            <Link
              to="/contact"
              data-testid="final-cta-get-started"
              className="inline-flex items-center rounded-full bg-accent px-8 py-3.5 text-sm font-bold text-white transition-all duration-200 hover:-translate-y-px hover:bg-[rgb(42_103_137)]"
            >
              Get Started
            </Link>
            <a
              href={SITE.phoneHref}
              data-testid="final-cta-contact"
              className="inline-flex items-center gap-2 rounded-full border border-white/30 px-8 py-3.5 text-sm font-bold text-white transition-colors hover:bg-white/10"
            >
              <Phone className="h-4 w-4" aria-hidden="true" />
              Contact Postings
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
